import { useEffect, useState } from 'react';
import './AiSpawnMarker.css';
import { useCameraStateContext } from '../../contexts/CameraContext';
import { useAiChatPanelContext } from '../../contexts/AiChatPanelContext';
import { FIRST_BLOCK_OFFSET_X, FIRST_BLOCK_OFFSET_Y, SPAWN_VERTICAL_RATIO, CAMERA_TOP_OFFSET } from '../AiChatPanel/engine/spawnOrigin';

function AiSpawnMarker() {
    const { isOpen, spawnPosition, setSpawnPosition } = useAiChatPanelContext();
    const { panzone } = useCameraStateContext();
    const [transform, setTransform] = useState({ x: 0, y: 0, scale: 1 });

    useEffect(() => {
        if (!panzone) return;

        setTransform(panzone.getTransform());
        const onTransform = () => setTransform(panzone.getTransform());
        panzone.on('transform', onTransform);

        return () => panzone.off('transform', onTransform);
    }, [panzone]);

    if (!isOpen || !panzone) return null;

    const screenToWorld = (clientX, clientY) => {
        const current = panzone.getTransform();
        return {
            x: (clientX - current.x) / current.scale,
            y: (clientY - CAMERA_TOP_OFFSET - current.y) / current.scale,
        };
    };

    const onMouseDown = (e) => {
        e.preventDefault();

        const onMouseMove = (moveEvent) => {
            setSpawnPosition(screenToWorld(moveEvent.clientX, moveEvent.clientY));
        };
        const onMouseUp = () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    };

    let left, top;
    if (spawnPosition) {
        left = spawnPosition.x * transform.scale + transform.x;
        top = CAMERA_TOP_OFFSET + spawnPosition.y * transform.scale + transform.y;
    } else {
        const visibleWidth = window.innerWidth;
        const visibleHeight = window.innerHeight - CAMERA_TOP_OFFSET;
        left = visibleWidth / 2 + FIRST_BLOCK_OFFSET_X * transform.scale;
        top = CAMERA_TOP_OFFSET + visibleHeight * SPAWN_VERTICAL_RATIO + FIRST_BLOCK_OFFSET_Y * transform.scale;
    }

    return (
        <div
            className="ai_spawn_marker"
            style={{ left, top }}
            title="First block generated by Teia appears here — drag to move, double-click to recenter"
            onMouseDown={onMouseDown}
            onDoubleClick={() => setSpawnPosition(null)}
        >
            <div className="ai_spawn_marker_dot"></div>
            <span className="ai_spawn_marker_label">Teia</span>
        </div>
    );
}

export default AiSpawnMarker;
